<template>
	<div v-on-clickaway="clickAway">
		<!--<div class="customizer-links d-none" :class="{'open' : open }" id="inner-customizer">
			<div class="nav flex-column nac-pills" id="c-pills-tab" role="tablist" aria-orientation="vertical">
				<a href="javascript:void(0)" class="nav-link" :class="{'active show': open == 'color' }" id="c-pills-profile-tab" @click="openFilter('color')">
					<div class="settings color-settings"> 
						<feather type="filter"></feather>
					</div>
				</a>
			</div>
		</div>-->
		<div class="customizer-contain" :class="{'open' : open }">
			<div class="tab-content">
				<div class="customizer-header">
					<h5 class="m-0">Filtros</h5>
					<i class="fa fa-times icon-close" @click="open = ''"></i>
				</div>
				<div class="customizer-body custom-scrollbar">
					<div class="tab-pane mb-4">




						<h6 class="filter-level" v-if="work_group_view">Grupo de Trabajo</h6>
			
						<b-dropdown v-if="work_group_view" variant="light" right class="main_filter_combo">
							<template v-slot:button-content>
								<span class="b-dropdown-value">{{ ((main_filter_labels.work_group_name == null)?'':main_filter_labels.work_group_name) }}</span>
							</template>
							<b-dropdown-item v-for="item in empresas" @click="cambioWorkGroup(item)" :key="item.id" :disabled="loading">{{ item.label }}</b-dropdown-item>
						</b-dropdown>





						<div class="filter-level" v-if="dates_view" style="display: inline-flex;width: 100% !important;">
							<h6>Fechas</h6>
							<b-form-checkbox v-model="dateEnable" :disabled="loading" @change="dateEnableChange"
							switch size="md" style="margin-left: auto;"></b-form-checkbox>
						</div>

						<div v-if="dates_view" :class="(dateEnable)?'datepicker_main_filter':'datepicker_main_filter_disabled'">
							<date-range-picker opens="left" @update="cambioFechas()" :singleDatePicker="false" :timePicker="false" :timePicker24Hour="true" 
							:disabled="loading || !dateEnable"
								:showWeekNumbers="false" :showDropdowns="true" :autoApply="true" v-model="dateRange" :ranges="undefined" style="width: 100%;">
								<div slot="input" slot-scope="picker">
								{{ dateRangePickerMask(picker.startDate) }} - {{ dateRangePickerMask(picker.endDate) }}
								</div>
							</date-range-picker>
						</div>
						
						




						<div class="filter-level" v-if="state_case_view" style="display: inline-flex;width: 100% !important;">
							<h6>Estado</h6>
							<b-form-checkbox v-model="stateCaseEnable" :disabled="loading" @change="stateCaseEnableChange"
							switch size="md" style="margin-left: auto;"></b-form-checkbox>
						</div>

						<b-dropdown v-if="state_case_view" variant="light" right :class="(stateCaseEnable)?'main_filter_combo':'main_filter_combo_disabled'">
							<template v-slot:button-content>
								<span class="b-dropdown-value">{{ ((main_filter_labels.case_state_name == null)?'':main_filter_labels.case_state_name) }}</span>
							</template>
							<b-dropdown-item v-for="item in estado_casos" @click="cambioEstadoCaso(item)" :key="item.id" :disabled="loading || !stateCaseEnable">{{ item.label }}</b-dropdown-item>
						</b-dropdown>




						<div class="filter-level" v-if="state_invoice_view" style="display: inline-flex;width: 100% !important;">
							<h6>Estado</h6>
							<b-form-checkbox v-model="stateInvoiceEnable" :disabled="loading" @change="stateInvoiceEnableChange"
							switch size="md" style="margin-left: auto;"></b-form-checkbox>
						</div>

						<b-dropdown v-if="state_invoice_view" variant="light" right :class="(stateInvoiceEnable)?'main_filter_combo':'main_filter_combo_disabled'">
							<template v-slot:button-content>
								<span class="b-dropdown-value">{{ ((main_filter_labels.invoice_state_name == null)?'':main_filter_labels.invoice_state_name) }}</span>
							</template>
							<b-dropdown-item v-for="item in estado_facturas" @click="cambioEstadoFactura(item)" :key="item.id" :disabled="loading || !stateInvoiceEnable">{{ item.label }}</b-dropdown-item>
						</b-dropdown>





						<div class="filter-level" v-if="state_project_view" style="display: inline-flex;width: 100% !important;">
							<h6>Estado</h6>
							<b-form-checkbox v-model="stateProjectEnable" :disabled="loading" @change="stateProjectEnableChange"
							switch size="md" style="margin-left: auto;"></b-form-checkbox>
						</div>
			
						<b-dropdown v-if="state_project_view" variant="light" right :class="(stateProjectEnable)?'main_filter_combo':'main_filter_combo_disabled'">
							<template v-slot:button-content>
								<span class="b-dropdown-value">{{ ((main_filter_labels.project_state_name == null)?'':main_filter_labels.project_state_name) }}</span>
							</template>
							<b-dropdown-item v-for="item in estado_proyectos" @click="cambioEstadoProyecto(item)" :key="item.id" :disabled="loading || !stateProjectEnable">{{ item.name }}</b-dropdown-item>
						</b-dropdown>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

import moment from 'moment'
import DateRangePicker from './utils/date_range_picker/DateRangePicker'
import { mapState } from "vuex";
import {mixin as clickaway} from 'vue-clickaway'

export default {
	components: {
		DateRangePicker
	},
	mixins: [clickaway],
	computed: {
		...mapState({
			filtros: state => state.main_filters,
      		loading: state => state.main_loading.loading,
      		filter_state: state => state.main_loading.open_filter
		}),
		work_group_view () {
			if (this.filtros.module_name == "case" || this.filtros.module_name == "rate" || this.filtros.module_name == "contact" || this.filtros.module_name == "product" || this.filtros.module_name == "invoice" || this.filtros.module_name == "project")	 
				return true;
			else
				return false;
		},
		state_case_view () { 
			if (this.filtros.module_name == "case")	 
				return true;
			else
				return false;
		},
		state_invoice_view () { 
			if (this.filtros.module_name == "invoice")	 
				return true;
			else
				return false;
		},
		state_project_view () { 
			if (this.filtros.module_name == "project")	 
				return true;
			else
				return false;
		},
		dates_view () { 
			if (this.filtros.module_name == "case" || this.filtros.module_name == "dashboard_billing")	 
				return true;
			else
				return false;
		},
	},
	watch: {
		filter_state: {
			handler () {
				this.open_external = true
				this.openFilter('color')
			},
			deep: true
		},
	},
	data(){
		return{
			open: "",
			open_external: false,
			enable: true,
			empresas: [],
			estado_casos: [],
			estado_facturas: [],
			estado_proyectos: [],
			dateRange: null,
			dateEnable: false,
			stateCaseEnable: false,
			stateInvoiceEnable: false,
			stateProjectEnable: false,
			main_filter_labels: {},
		}
	},
	mounted(){

		if ( this.dateRange == null ) {
			if (localStorage.dateRange != null && localStorage.dateRange != undefined && localStorage.dateRange != "") {
				this.dateRange = JSON.parse(localStorage.dateRange)
			} else {
				this.dateRange = {
					startDate: moment().startOf('month'),
					endDate: moment().endOf('month')
				}
			}
			this.cambioFechas()
		}
			
		this.getEmpresas()
			.then(data => {
				this.empresas = data.items;
				if(localStorage.work_group_id > 0){
					this.empresas.forEach(element => {
						if (element.id == localStorage.work_group_id) {
							this.cambioWorkGroup(element)
						}
					});
				} else {
					if(data.items.length > 0){
						this.cambioWorkGroup(data.items[0])
					}
				}
			})	
	},
	methods: {
		clickAway () {
			if (!this.open_external) {
				this.open = ""
			} else {
				this.open_external = false
			}
		},
		openFilter (val) {
			if (this.open != "") {
				this.open_external = false
				this.open = ""
			} else {
				this.getEmpresas()
					.then(data => {
						this.empresas = data.items;
						this.open = val
					})
			}	
		},
		cambioWorkGroup(item) {
			if (this.filtros.work_group_id != item.id) {
				this.main_filter_labels.work_group_name = item.label
				this.$store.dispatch('main_filters/setWorkGroup', item.id)

				this.getEstadosPorEmpresaFilter(this.filtros.work_group_id)
					.then(data => {
						this.estado_casos = data.items

						/*this.estado_casos.forEach(element => {
							if (element.id == -2) {
								this.cambioEstadoCaso(element)
							}
						});*/
				})

				this.getEstadosFacturaPorEmpresaFilter(this.filtros.work_group_id)
					.then(data => {
						this.estado_facturas = data.items

						/*this.estado_facturas.forEach(element => {
							if (element.id == -1) {
								this.cambioEstadoFactura(element)
							}
						});*/
				})

				/*this.getProyectoEstados()
					.then(data => {
						if (data) {
							if (data.items) {
								this.estado_proyectos = data.items
							}
						}
					})*/

			}	
		},
		stateCaseEnableChange (value) {
			if (value) {
			} else {
				this.main_filter_labels.case_state_name = ""
				this.$store.dispatch('main_filters/setStateCase', null)
			}
		},
		stateInvoiceEnableChange (value) {
			if (value) {
			} else {
				this.main_filter_labels.invoice_state_name = ""
				this.$store.dispatch('main_filters/setStateInvoice', null)
			}
		},
		cambioEstadoCaso(item) {
			if (this.filtros.case_state_id != item.id) {
				this.main_filter_labels.case_state_name = item.label
				this.$store.dispatch('main_filters/setStateCase', item.id)
			}	
		},
		cambioEstadoFactura(item) {
			if (this.filtros.invoice_state_id != item.id) {
				this.main_filter_labels.invoice_state_name = item.label
				this.$store.dispatch('main_filters/setStateInvoice', item.id)
			}	
		},
		stateProjectEnableChange (value) {
			if (value) {
			} else {
				this.main_filter_labels.project_state_name = ""
				this.$store.dispatch('main_filters/setStateProject', null)
			}
		},
		cambioEstadoProyecto(item) {
			if (this.filtros.project_state_id != item.id) {
				this.main_filter_labels.project_state_name = item.name
				this.$store.dispatch('main_filters/setStateProject', item.id)
			}	
		},
		dateEnableChange (value) {
			if (value) {
				this.$store.dispatch('main_filters/setDateRange', this.dateRange)
			} else {
				this.$store.dispatch('main_filters/setDateRange', null)
			}
		},
		cambioFechas () {
			if (this.filtros.dateRange != this.dateRange && this.dateEnable) {
				this.$store.dispatch('main_filters/setDateRange', this.dateRange)
			}
		},
	}
}
</script>